import es from 'vuetify/es5/locale/es';

export default {
  $vuetify: {
    ...es,
  },
  commons: {
    accept: 'Aceptar',
    decline: 'Rechazar',
    loading: 'Cargando',
    close: 'Cerrar',
    previous: 'Anterior',
    next: 'Siguiente',
    pageOf: '{0} de {1}',
    cancel: 'Cancelar',
    ok: 'OK',
    send: 'Enviar',
    viewMore: 'Ver más',
    search: 'Buscar',
  },
  input: {
    user: 'Introduce usuario',
    password: 'Introduce contraseña',
    label: 'Introduce tu usuario DMSAS',
  },
  validation: {
    required: 'Por favor, introduce un valor',
    email: 'Introduce un correo válido',
    emailSAS: 'Introduce tu correo corporativo (@juntadeandalucia.es)',
    tel: 'Puedes incluir un teléfono de 6 o 9 dígitos',
    textRoom: 'La sala no debe contener más de 30 caracteres',
    mobile: 'Introduce un número móvil',
    file: {
      size: 'El tamaño supera el limite permitido (20mb)',
      required: 'Por favor, añade un archivo',
      length: 'Número máximo de ficheros alcanzado (8)',
    },
    dmsas: 'Introduce un usuario DMSAS válido',
    profileForm: 'Añade al menos un teléfono de contacto y un email, para que podamos ofrecerte una experiencia mas personalizada.',
    dateTime: '*Por favor, selecciona una fecha',
    dateRangeClosed: 'Para filtrar las solicitudes cerradas debes seleccionar un periodo de fechas. Máximo 3 meses.',
    ldap: {
      sspaext: 'Debes utilizar el formulario de registro: ',
      sspagen: 'Lo sentimos, no es posible tramitar VPN para usuarios genéricos',
      notsassspafibao: 'Lo sentimos, la cuenta de correo no pertenece al organismo SAS. Debes solicitar la VPN a través de tu organismo',
      fibao: 'Debes tramitar alta a través de Alta VPN usuario externo',
      empty: 'La cuenta de correo indicada no está identificada en el directorio corporativo. Comprueba tu cuenta de correo en tu ',
    },
    vpnUser: 'Este usuario ya tiene VPN',
    extendedSearchOverResults: 'Se han encontrado un número elevado de resultados. Se recomienda añadir más criterios de búsqueda.',
  },
  menu: {
    home: 'Inicio',
    createRequest: 'Crear solicitud',
    request: 'Petición',
    incident: 'Incidencia',
    problem: 'Problema',
    myRequestsGroup: 'Mis solicitudes',
    requests: 'Peticiones',
    incidents: 'Incidencias',
    problems: 'Problemas',
    approvals: 'Aprobaciones',
    kdbList: 'Busca tu solución',
    helpList: 'Ayuda',
    legalDisclaimer: 'Aviso legal',
    accesibility: 'Accesibilidad',
    suggestions: 'Sugerencias y comentarios',
    lockMenu: 'Bloquear menú',
    unlockMenu: 'Desbloquear menú',
    cache: 'Administrar caché',
    privacy: 'Seguridad y privacidad',
    deleteAccount: 'Eliminar cuenta',
    calltome: 'Te llamamos',
  },
  navbar: {
    title: 'MiCentroServicios',
    portalcges: 'Portal CGES',
    help: 'Ayuda',
    rate: 'Valorar la aplicación',
    logout: 'Cerrar sesión',
    utils: 'Utilidades',
    search: 'Buscar',
    profile: 'Perfil',
    errors: {
      portalcges: 'Para acceder a Portal Cges debes estar conectado a la Red Corporativa de la Junta de Andalucía',
    },
    requestSearch: '¿Qué necesitas pedir?',
    incidentSearch: '¿Qué incidencia tienes?',
    security: 'Seguridad y privacidad',
    mySubscriptions: 'Mis suscripciones',
    myNotifications: 'Mis notificaciones',
    news: 'Noticias',
    configuration: 'Configuración',
    subscribe: 'Suscribirse',
  },
  views: {
    login: {
      forgotPassword: '¿Has olvidado tu contraseña?',
      updatePassword: 'Modificar Contraseña',
      signin: 'Iniciar sesión',
      remember: 'Recordar usuario',
      error: {
        unkown: 'Ha ocurrido un error inesperado',
        401: 'El nombre de usuario o contraseña no es correcto. Inténtalo de nuevo.',
        404: 'El servicio no se encuentra disponible en este momento. Inténtalo de nuevo más tarde.',
        500: 'Estamos experimentando problemas internos, por favor si persiste el problema contacta con el administrador.',
        504: 'El servicio no se encuentra disponible en este momento. Inténtalo de nuevo más tarde.',
      },
      messages: {
        sessionCaduced: 'La sesión ha expirado, por favor, introduce de nuevo tus credenciales',
        invalidBopsid: 'La clave de seguridad introducida no es válida o ya ha expirado',
      },
    },
    legalDisclaimer: {
      title: 'Aviso legal',
      body: '<u><b>Normativa de uso</b></u><br/><p align="justify">El uso de este sistema está sujeto a lo dispuesto en el Código de Conducta en el uso de las Tecnologías de la Información y la Comunicación para profesionales públicos de la Administración de la Junta de Andalucía, aprobado por Resolución de 22 de octubre de 2020, de la Secretaría General para la Administración Pública <b><a href="https://www.juntadeandalucia.es/boja/2020/208/34"  target="_blank">(BOJA nº 208 de 27/10/2020)</a></b>. Te rogamos que leas detenidamente lo dispuesto en este documento. La información a la que accedes a través de este sistema solo podrá ser usada para los fines autorizados.</p><br/><u><b>Privacidad de la información</b></u><br/><p align="justify">En cumplimiento del Reglamento General de Protección de Datos (UE) 2016/679, Ley Orgánica 3/2018 de 5 de diciembre y demás normativa relacionada, el Servicio Andaluz de Salud (SAS), como responsable del tratamiento, te informa que los datos tratados en el servicio "ayudaDIGITAL" a través de todos sus canales, tienen la finalidad de ofrecerte la cobertura y el soporte que precises para el uso de los sistemas de información en el desempeño de tu labor profesional asistencial o de gestión y servicios.</p><br /><p align="justify">Tú eres el titular de dicha información y por tanto podrás ejercer tus derechos de acceso, rectificación, oposición, supresión o cualquier otro reconocido, como se indica en el enlace: <b><a href="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/protecciondedatos"  target="_blank">https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/protecciondedatos</a></b> así como consultar cualquier cuestión relacionada con tus datos o la protección de tu privacidad a través de la dirección de correo <b><a href="mailto:dpd.sspa@juntadeandalucia.es" target="_blank">dpd.sspa@juntadeandalucia.es</a></b>.</p><br/><p align="justify">En el caso particular del canal WhatsApp, debes tener en cuenta que desde que se realiza la solicitud de baja del servicio hasta que esta se hace efectiva puede transcurrir un periodo de tiempo durante el cual podría recibir mensajes que se encuentren pendientes de entrega. Estos mensajes serían los últimos que recibirías por este canal.</p></br><u><b>Uso de librerías de terceros</b></u><br/><p align="justify">El aplicativo utiliza liberías de terceros que pueden ser consultadas <a href="https://www.sspa.juntadeandalucia.es/servicioandaluzdesalud/ayudadigital/sites/default/files/repositorio/2023-09/uso_libreria_de_terceros.pdf" target="_blank">aquí</a>.</p>',
    },
    thirdParty: {
      title: 'Recursos de terceros',
      body: '<p class="mt-2 "align="justify">Para el desarrollo y mantenimiento de esta plataforma se utilizan recursos y herramientas de terceros (frameworks, librerías, iconos) de carácter libre y no privativo.</p>',
    },
    accesibility: {
      title: 'Accesibilidad',
      body: '<u><b>Declaración de Accesibilidad</b></u><br/><p align="justify"><br>La aplicación móvil ayudaDIGITAL está siendo mejorada para proporcionar a todas las personas, cualquiera que sea su capacidad, el mayor grado de accesibilidad a sus contenidos, garantizando así tanto un acceso equitativo como la igualdad de oportunidades.</a></b><br/><br> Según lo anterior, ayudaDIGITAL está comprometida con la supresión de las barreras de accesibilidad que imposibiliten o dificulten la utilización de la citada aplicación móvil, razón por la cual se está trabajando para conseguir un grado adecuado de cumplimiento de las normas de accesibilidad, de manera que la información sea accesible en diferentes situaciones, permitiendo así a todas las personas navegar e interactuar con la aplicación móvil, percibiendo y entendiendo sus contenidos. Se trata de adoptar las medidas necesarias para que la información actualmente existente sea accesible por todos los usuarios, minimizando las restricciones no solo de tipo tecnológico sino también las causadas por las distintas formas de percepción de los usuarios.</p><u><b>Contenido no accesible</b></u><br/><p align="justify"><br>La aplicación ayudaDIGITAL es parcialmente conforme con la legislación en los aspectos de accesibilidad, debido a la falta de conformidad de los aspectos que se indican a continuación.</a></b><br/><br>Perceptibilidad: Puede encontrarse algún contenido textual por el cuál el tamaño de este no sea correctamente visible. Támbien existe contenido no textual (objetos gráficos) en los que el contraste no es el idóneo.</p><p>Operatibilidad: Existen etiquetas que forman parte de la interfaz de usuario que incluyen texto o imágenes de texto cuyo nombre no contiene el texto que se presenta visualmente.<p/><u><b>Contenido que no entra dentro del ámbito de la legislación aplicable</b></u><br/><p align="justify">Aunque se está procurando el cumplimiento, podrían existir aún archivos ofimáticos en PDF, de contenido multimedia u otros formatos publicados que no cumplen en su totalidad todos los requisitos de accesibilidad.</a></b></p><u><b>Preparación de la presente declaración de Accesibilidad</b></u><br/><br>La presente declaración ha sido preparada por primera vez el día 10 de Enero de 2022, tras una evaluación de accesibilidad llevada a cabo por las personas que conforman ayudaDIGITAL. La aplicación no ha tenido revisiones posteriores.<p align="justify"><br></p><u><b>Contenido opcional</b></u><br/><p align="justify"><br>La aplicación móvil está diseñada para su visualización responsive, con lo que se visualiza de forma óptima en todos dispositivos móviles.</a></b></p>',

    },
    deleteAccount: {
      title: 'Tu cuenta',
      body: '<u><b>Eliminar cuenta de usuario</b></u><br/><p align="justify"><br>Si desea eliminar su cuenta pulse en el botón "Eliminar Cuenta" ubicado bajo este texto. Se procederá entonces a la eliminación de todos sus datos. Este proceso no solicitará confirmación, por lo que de no estar seguro, no continúe.</a></b><br/>',
      delete: 'Eliminar cuenta',
    },
    requestCreationView: {
      breadcrumbs: {
        request: 'Peticiones',
      },
      bookmarksSyncError: 'Ha ocurrido un error sincronizando tus favoritos por lo que es posible que los cambios no se guarden. Por favor, si el problema persiste, contacta con el administrador del sistema',
    },
    form: {
      create: 'Crear',
      createAndResolve: 'Crear y resolver',
      send: 'Enviar',
      messages: {
        creating: 'Procesando datos de la solicitud',
        uploadingAttachments: 'Subiendo adjuntos ({0} de {1})',
        created: {
          R: 'Petición creada correctamente',
          I: 'Incidencia creada correctamente',
          P: 'Problema creado correctamente',
        },
        error: 'Ocurrió un error al procesar su solicitud [{0}]',
      },
      overrideUserWorkplace: '¿Quieres actualizar tu información personal con este centro de trabajo?',
      overrideOtherUserWorkplace: '¿Quieres actualizar la información personal del usuario con este centro de trabajo?',
      feedbackPlaceholder: 'Indícanos qué parte del formulario no ha funcionado correctamente o qué mejorarías.',
    },
    ticketList: {
      empty: 'No hay resultado para tu búsqueda',
      export: 'Exportar',
      filters: {
        search: 'Buscar',
        name: 'Filtros',
      },
      status: {
        FIX: 'Pte. confirmar cierre',
        DEL: 'Planificada',
        PEND_PRES: 'Pte. presupuesto',
      },
      openedBy: 'por {0} | por {0} para {1}',
      openDate: 'Registrada el {0}',
      lastModDt: 'actualizada el {0}',
      resolveDate: 'Resuelta el {0}',
      closeDate: 'y cerrada el {0}',
      locationTicket: 'Ubicación: {0}',
      asignee: 'Asignada: {0} | Asignada: {0} {1}',
      search: {
        placeholder: {
          R: 'Busca tus solicitudes',
          I: 'Busca tus incidencias',
          P: 'Busca tus problemas',
        },
      },
      total: 'Ninguna solicitud | 1 solicitud | {n} solicitudes',
    },
    ticketListPend: {
      type: {
        R: 'P',
        I: 'I',
        P: 'Pr',
      },
      color: {
        R: '#99c2a5',
        I: '#cdcd9c',
        P: '#c55a11',
      },
      placeholder: 'Busca tus solicitudes',
      total: 'Ninguna solicitud | 1 Solicitud | {n} Solicitudes',
    },
    ticketDetail: {
      expande: {
        more: 'VER MÁS',
        less: 'VER MENOS',
      },
      activities: {
        sectionTitle: 'Actividades',
      },
      workFlow: {
        sectionTitle: 'Aprobadores / Resolutor',
      },
      requiredInformation: {
        title: 'Acción requerida',
        plannedDate: 'Fecha planificada:',
      },
      detailsSectionTitle: 'Detalles',
      detailsMore: 'más',
      activitiesSectionTitle: 'Actividades',
      additionalInfo: {
        sectionTitle: 'Información adicional',
        location: 'Ubicación de la solicitud',
        environment: 'Entorno',
        totalClaims: 'Total reclamaciones',
        isClaimFromParent: 'Es una reclamación de',
        claimType: 'Tipo de reclamación',
        isClaimFromOrigin: 'Ya existe una solicitud que contiene o generaliza lo que se solicita en esta petición',
        phoneTicket: 'Teléfono de contacto',
        phoneTicketModify: 'Actualización solicitud.',
        phoneTicketSuccess: 'Solicitud actualizada correctamente.',
        phoneTicketError: 'Se ha producido un error.',
        notValidEmpty: 'Debes completar un teléfono de contacto',
        notValidDigi: 'El teléfono de contacto debe contener 6 o 9 dígitos.',
      },
      claimsTable: {
        Title: 'Reclamaciones relacionadas',
        code: 'Código',
        type: 'Motivo',
        date: 'Fecha/Hora apertura',
        state: 'Estado',
      },
      attach: {
        list: 'Adjuntos',
        delete: {
          process: 'Eliminando fichero',
          dialog: '¿Borrar {0}?',
          accept: 'Aceptar',
          reject: 'Rechazar',
        },
        error: 'Error a eliminar el fichero',
        success: 'Fichero eliminado correctamente',
      },
      subscriptions: {
        title: 'Interesados',
        list: 'Lista de interesados (podrán realizar cualquier acción sobre esta solicitud).',
        interesado: 'Eres interesado de esta solicitud',
        seguidor: 'Eres seguidor de esta solicitud',
        max: 'Has alcanzado el número máximo de interesados.',
        noBody: 'No hay interesados.',
        process: 'Eliminando interesado.',
        success: 'Interesado eliminado correctamente.',
        error: 'Error a eliminar un interesado.',
      },
    },
    ticketDetailTic: {
      title: {
        follow: 'Seguir',
        followNot: 'Dejar de seguir',
        share: 'Compartir',
      },
      pulso: {
        openDate: 'Fecha apertura:',
        resource: 'Recurso:',
        type: 'Tipo:',
        contacts: 'Nº de contactos:',
        claims: 'Nº de reclamaciones:',
        location: 'Localización:',
      },
      organizacion: {
        title: 'Datos del usuario asignado',
        user: 'Usuario:',
        location: 'Organización:',
        lastDate: 'Fecha última asignación:',
      },
      send: {
        creating: 'Enviando solicitud',
        ok: 'SI - Se ha ejecutado correctamente.',
        ko: 'NO - Se ha ejecutado correctamente.',
      },
    },
    profileEdit: {
      update: 'Guardar cambios',
      titleSection: 'Seguridad y privacidad',
      altirisMessage: 'Este equipo está actualmente conectado a {0}. Para actualizar tu ubicación pincha en "Actualizar" y "Guardar cambios".',
      session: {
        title: 'Últimos inicios de sesión',
        date: '{0}',
        symbol: {
          chrome: 'google-chrome',
          internet: 'microsoft-internet-explorer',
          microsoft: 'microsoft-edge',
          safari: 'apple-safari',
          android: 'android',
          ios: 'apple-ios',
          firefox: 'firefox',
          unknow: 'web',
        },
        unknow: 'Desconocido',
        logoutDevicesLink: 'Desvincular Dispositivo',
      },
      legal: 'Normativa de uso de tus datos personales',
      form: {
        messages: {
          creating: 'Actualizando datos del perfil',
          created: 'Perfil actualizado',
          error: 'Ha ocurrido un error durante el proceso de actualización. {0}',
          errorWhatsApp: '<strong>No es posible activarte el WhatsApp en este número de móvil</strong> porque ya lo tiene habilitado otro usuario.<br><br>Para que podamos atenderte por WhatsApp, te aconsejamos habilites este canal con el mismo número de móvil que tienes identificado en AGESCON, para recuperar tu contraseña de DMSAS.',
          invalid: 'Errores en el formulario',
          invalidPhone: 'Añade al menos un teléfono de contacto para que podamos ofrecerte una experiencia más personalizada.',
        },
      },
      popup: {
        title: 'Verificación de móvil de contacto',
        text: 'Para completar la actualización de tu móvil de contacto, introduce el código numérico que has recibido por SMS.',
        textCadu: 'El códico caducará en 1 hora.',
        timeLeft: 'Tiempo restante:',
        submitText: 'Verificar código',
        cancel: 'Cancelar',
        resend: 'Reenviar código',
        send: 'Enviar',
      },
      sms: {
        ok: 'Se han actualizado correctamente',
        errorCode: 'El código introducido es incorrecto, inténtelo de nuevo.',
        errorMax: 'Se han agotado los intentos de envío del código de verificación. Por favor, contáctanos en el 955 01 70 00 para que podamos ayudarte.',
        errorPriTelephone: 'No ha sido posible actualizar el móvil de contacto',
      },
    },
    navigationTickets: {
      goToList: 'Volver al listado',
    },
    notificationDetails: {
      filterItem: {
        all: 'Todas',
        email: 'Email',
        movil: 'Móvil',
        sms: 'SMS',
        applications: 'Aplicaciones',
        requests: 'Solicitudes',
        news: 'Destacados',
        others: 'Otros',
        interruptions: 'Interrupciones',
        communications: 'Comunicaciones',
      },
      bussinessType: 'Tipo de notificación',
      goToList: 'Ir al listado',
      empty: 'No se ha encontrado ninguna notificación',
      lisTitle: 'Mis notificaciones',
      from: 'De',
      received: 'Recibido',
      detailTitle: 'Información de notificación',
      notFound: 'La información solicitada no existe o no dispones de permisos para acceder a ella',
    },
    faqsItems: {
      searchText: '¿Qué necesitas saber?',
      total: 'Ninguna sección del manual | 1 Sección del manual | {n} Secciones del manual',
      empty: 'No hay resultado para tu búsqueda. Si quieres registrar tu consulta, pincha',
      url: {
        text: 'aquí',
        to: 'request/FE5874A5157701F8B264000C2975418F/AA223478158A01F8A7BE000C2975418F',
      },
    },
    approveList: {
      checkAll: 'Marcar los 10 primeros',
      uncheckAll: 'Desmarcar los 10 primeros',
      approverSelect: 'Aprobar seleccionadas',
      rejectSelect: 'Rechazar seleccionadas ',
      action: {
        approver: 'aprobar',
        reject: 'rechazar',
      },
      total: 'Ninguna petición | 1 petición | {n} peticiones',
      search: {
        placeholder: 'Busca tus peticiones',
      },
      filterItem: {
        PEND_APRO: 'Pte. aprobar',
        RCHZ: 'Rechazada',
        APPVAL: 'Aprobada',
      },
    },
    cache: {
      title: 'Cada botón borrará los datos en caché de ese objeto',
      response: {
        success: 'La memoria caché del objeto se eliminó correctamente',
        notFound: 'El objeto actualmente no está en caché',
        error: 'Error en la limpieza de la caché',
      },
    },
    knowledgeItems: {
      technicalTab: 'Información técnica',
      userTab: 'Información usuario final',
      listTitle: 'Busca tu solución',
      searchText: '¿Qué necesitas saber?',
      notFound: 'La información solicitada no existe o no dispones de permisos para acceder a ella',
      listType: {
        filtered: 'No se ha encontrado ninguna solución | Una solución | {n} soluciones',
        related: 'No se ha encontrado ninguna solución | Una solución relacionada con tus últimas solicitudes | {n} soluciones relacionadas con tus últimas solicitudes',
        mostVisited: 'No se ha encontrado ninguna solución | La solución mejor valorada | {n} soluciones más consultadas',
      },
      publishedDate: 'Publicado el {0}',
      modifyDate: 'Actualizado el {0}',
      vote: 'valoración',
      votes: 'valoraciones',
      technical: 'Técnica',
      share: {
        title: 'Compartir',
      },
      fav: {
        title: 'Favoritos',
      },
      rate: {
        title: 'Valorar',
        cancel: 'Cancelar',
        send: 'Valorar',
        commentPlaceholder: 'Por favor, introduce un comentario',
        rateTitle: '¿Te ha sido útil esta información?',
        ratingQuestion: {
          question: '¿Te ha sido útil?',
          much: 'Mucho',
          little: 'Poco',
          none: 'Nada',
        },
        solvingQuestion: {
          question: '¿Ha resuelto la información tu consulta?',
          yes: 'Sí',
          no: 'No',
        },
      },
      messages: {
        sendingRating: 'Enviando valoración',
        ratingSent: '¡Gracias! Tu opinión nos ayuda a mejorar',
        ratingSendingError: 'Error enviando valoración',
      },
    },
    globalSearch: {
      tabs: {
        requestsItems: 'CREAR SOLICITUD',
        requests: 'MIS SOLICITUDES',
        knowledgeItems: 'BUSCAR SOLUCIÓN',
      },
      requestsItems: {
        notFound: 'No se ha encontrado ningún resultado',
        notFoundSearch: 'No se ha encontrado ningún resultado para tu búsqueda, inténtalo con otros criterios.',
        notFoundSearchFirstLoad: 'No se ha encontrado ningún resultado.',
        notFoundSearchLink: 'No se ha encontrado ningún resultado para tu búsqueda, inténtalo con otros criterios o registra ',
        notFoundSearchLinkclick: 'aqui',
        notFoundSearchLinkEnd: 'tu solicitud.',
      },
    },
    permissionsMobile: {
      title: 'Permisos App',
      body: 'Estos permisos solo se utilizan para lo que aquí se describe, para que puedas usar plenamente la app. Puedes modificar los permisos desde los ajustes de tu dispositivo',
      list: {
        internet: {
          title: 'Internet',
          subtitle: 'Acceso a internet para ver el contenido de la aplicación y de tus solicitudes.',
        },
        readAndWrite: {
          title: 'Lectura y Escritura',
          subtitle: 'Acceso a la memoria del dispositivo en lectura y escritura para que puedas adjuntar archivos a tus incidencias o peticiones o descargarte los documentos adjuntos a estas solicitudes.',
        },
        biometric: {
          title: 'Uso Biométrico',
          subtitle: 'Acceso al uso biométrico para que tengas un acceso más seguro y cómodo sin tener que teclear tu usuario y contraseña cada vez que accedes a ayudaDIGITAL.',
        },
        camera: {
          title: 'Cámara',
          subtitle: 'Acceso a la cámara para que puedas adjuntar fotos a tus incidencias o peticiones, o escanear el código de barras de tus equipos, impresoras y monitores al abrir una incidencia hardware.',
        },
      },
    },
    devices: {
      title: 'Mis dispositivos registrados',
    },
    announcementapp: {
      title: 'Antes de irte...',
      subtitleTop: 'Te recordamos que también puedes registrar y consultar tus solicitudes en la app móvil ayudaDIGITAL.',
      subtitleBottom: 'Descárgala y lleva ayudaDIGITAL siempre en tu bolsillo.',
      android: 'Descarga para Android',
      iOS: 'Proximamente en iOS',
      sessionExpired: 'Tu sesión ha expirado',
    },
    surveyApp: {
      title: 'Valorar la aplicación',
      subtitle: 'Valora tu experiencia con la aplicación',
      valorationPlaceholder: '¿Quieres aportarnos alguna información adicional?',
      thanks: '¡GRACIAS! Utilizaremos tu experencia para seguir mejorando',
      error: 'Se ha producido un error, por favor intentelo mas tarde',
    },
    agescon: {
      title: 'Modificar Contraseña',
      subtitle: 'Introduce tu usuario DMSAS para que podamos desbloquearlo o ayudarte a restablecer tu contraseña.',
      labelComponent: 'Usuario DMSAS',
      labelButton: 'Enviar',
      closeButton: 'Finalizar',
      errors: {
        600002: 'Has realizado la solicitud para modificar tu contraseña. Si no has podido modificarla, espera unos minutos antes de volver a solicitarlo.',
        600004: 'Has realizado la solicitud para modificar tu contraseña. Si no has podido modificarla, espera unos minutos antes de volver a solicitarlo.',
        default: 'Lo sentimos, ha habido un problema en el proceso para modificar tu contraseña. Por favor, contacta con nosotros en el teléfono <a href="tel:955017000">955 01 70 00</a> (corporativo 31 70 00) para que podamos ayudarte a recuperar tu contraseña.',
      },
      finishType: {
        SMS: 'Para completar el proceso de modificación de tu contraseña, accede al enlace del SMS que te hemos enviado a tu teléfono móvil {destination} , proporcionado en AGESCON',
        MAIL: 'Para completar el proceso de modificación de tu contraseña, accede al enlace del correo electrónico que te hemos enviado a la dirección {destination}, proporcionada en AGESCON',
      },
      thanksMessage: '¡Gracias, {screenname}!',
    },
    trustedThirdParty: {
      title: 'Autorización de tercero de confianza',
      loadingAuth: 'Validanto autorización...',
      authSuccess: 'Autorización válida, redirigiendo a la página solicitada...',
      authError: 'Autorización inválida',
    },
    security: {
      unregisterDevice: {
        process: 'Cerrando sesión en móvil',
        dialog: '¿Cerrar la sesión en {0} - {1}?',
        accept: 'Aceptar',
        reject: 'Rechazar',
        cancel: 'Cancelar',
      },
      renameDevice: {
        process: 'Modificando el nombre del dispositivo',
        dialog: '¿Modificar el nombre del dipositivo {0} - {1}?',
        accept: 'Aceptar',
        reject: 'Rechazar',
        cancel: 'Cancelar',
      },
    },
    mySubscriptions: {
      searchBarLabel: 'Aplicación',
      title: 'Mis suscripciones',
      view: {
        msgTitle1: 'Suscríbete a las aplicaciones que sean de tu interés y',
        msgTitleBold: 'recibe notificaciones push',
        msgKOAgrupaciones: 'Lo sentimos, no se ha podido completar el proceso. Inténtalo de nuevo mas tarde.',
        msgOKAgrupaciones: 'El proceso se ha completado correctamente',
        msgTitle2: 'en tu móvil.',
        msgTitleQR: 'Para ello, descárgate la app móvil ayudaDIGITAL.',
        msgIT: 'Para ello, descárgate la',
        msgCustomer: 'Sólo recibirás estas notificaciones si tienes descargada la ',
        msgApp: 'app móvil ayudaDIGITAL',
      },
    },
    configuration: {
      title: 'Suscribirse',
      description: 'Selecciona el tipo de suscripción que quieres configurar.',
      canal: {
        mobile: 'Recibirás <b>notificaciones push</b> en tu móvil. Para ello, descárgate la app móvil ayudaDIGITAL.',
        whatsapp: 'Recibirás <b>mensajes en tu WhatsApp</b>. Recuerda indicar tu móvil en tu perfil y marcar el check de consentimiento.',
        email: 'Recibirás <b>correos electrónicos</b>. Recuerda indicar tu dirección en tu perfil.',
        general: 'Recibirás las notificaciones por los canales seleccionados si tus datos de contacto están completos en ',
      },
      applications: {
        title: 'Interrupciones de servicios',
        description: 'Información sobre interrupciones por mejoras o incidencias relevantes en los servicios digitales que sean de tu interés.',
        descripcionView: 'Información sobre interrupciones por mejoras o incidencias relevantes en los servicios digitales que sean de tu interés. </br> </br> ¿Cómo quieres recibir la notificación?',
        suscribeAreas: 'Suscríbete a las áreas de tu interés.',
        atLeastOneChannel: 'Para poder informarte sobre el estado de tus solicitudes, es necesario que tengas al menos un canal de notificación activado.',
      },
      requests: {
        title: 'Mis solicitudes',
        description: 'Información sobre tus solicitudes o de las que seas interesado.',
        explanationDescription: 'Estos avisos se enviarán siempre por los canales predefinidos, para garantizar que estés informado.',
        atLeastOneChannel: 'Para poder informarte sobre el estado de tus solicitudes, es necesario que tengas al menos un canal de notificación activado.',
      },
      communication: {
        title: 'Comunicaciones ayudaDIGITAL',
        description: 'Información general sobre el servicio que ofrece ayudaDIGITAL.',
        explanationDescription: 'Estos avisos se enviarán siempre por los canales predefinidos, para garantizar que estés informado.',
        atLeastOneChannel: 'Es necesario que tengas al menos un canal de notificación activado.',
      },
      remoto: {
        title: 'Asistencia remota',
        description: 'Autoriza temporalmente el acceso remoto a tu equipo para recibir soporte técnico.',
      },
    },
    utils: {
      title: 'Utilidades',
      description: 'Selecciona la utilidad que quieres ejecutar.',
      acortador: {
        title: 'Acortador de URLs',
        description: 'Convierte tus enlaces largos en URLs cortas y fáciles de compartir.',
        urlCopiada: 'URL copiada',
      },
      conversor: {
        title: 'Conversor telefónico',
        description: 'Convierte fácilmente un número largo (9 dígitos) en un número corto (6 dígitos) y viceversa.',
        tlfCopiado: 'Teléfono copiado',
      },
      qr: {
        title: 'Generador de códigos QR',
        description: 'Crea un código QR a partir de cualquier enlace o texto para compartirlo fácilmente.',
        otherQr: 'Generar otro QR',
        qrCopiado: 'Código QR copiado',
      },
      validadorDNI: {
        title: 'Verificador QR DNI',
        description: 'Escanea el código QR con MiDNI para verificar un DNI',
      },
    },
    home: {
      pendingRequests: {
        title: 'Solicitudes pendientes de mí',
        emty: 'No hay solicitudes pendientes de ti',
        code: 'Código',
        summary: 'Asunto',
        filterLabel: 'Estado',
        statuses: {
          FIX: 'Pte. confirmar cierre',
          OP: 'Abierta',
          DEL: 'Planificada',
          PEND_APRO: 'Pte aprobar',
          PL_ENT: 'Pte implantar',
          CL: 'Cerrada',
          CNCL: 'Cancelada',
          RCHZ: 'Rechazada',
          PEND_PRES: 'Pte. presupuesto',
        },
      },
      myRequests: {
        title: 'Mis solicitudes',
        emty: 'No hay solicitudes pendientes',
        code: 'Código',
        summary: 'Asunto',
        filterLabel: 'Estado',
      },
      requests: {
        title: '¿Necesitas pedir algo?',
        placeholder: 'Buscador de peticiones',
        favs: {
          show: 'Mostrar peticiones favoritas',
          hide: 'Ocultar peticiones favoritas',
        },
      },
      incidents: {
        title: '¿Algo no funciona bien?',
        placeholder: 'Buscador de incidencias',
        favs: {
          show: 'Mostrar incidencias favoritas',
          hide: 'Ocultar incidencias favoritas',
        },
      },
      lastAccess: 'Último inicio de sesión el {date} a las {time}',
      profileWarning: 'Perfil',
      pass: {
        notificationAlert: 'La contraseña de tu usuario {0} caducará en menos de {1} ',
        notificationAlertToday: 'La contraseña de tu usuario {0} caduca hoy.',
        notificationiasDay: 'día.',
        notificationiasDays: 'días.',
        notificationSend: 'Te hemos enviado un SMS al móvil terminado en',
        notificationEdit: ', con un enlace para que modifiques tu contraseña. Ten en cuenta los requisitos que se indican en dicho enlace para definir una contraseña válida',
        send: 'Enviando notificación...',
        ok: 'Se ha enviado la notificación correctamente',
        ko: 'Ha habido un error en el envio de la notificación',
        sendbtn: 'Modificar',
      },
      notSession: 'Para que podamos darte soporte, tienes que contactar a través del teléfono 955 01 70 52 o al buzón de correo ',
    },
    calltome: {
      title: 'Te llamamos',
      subtitle: '¿Necesitas ayuda y quieres que te llamemos?',
      check: 'Revisa tu teléfono de contacto y, si no es correcto, modifícalo en este formulario sólo para esta ocasión o en tu',
      profile: 'perfil de usuario',
      always: 'y quedará actualizado para siempre',
      text: 'Número de teléfono',
      btn: 'LLAMADME AHORA',
      service: 'Servicio disponible las 24 horas del día, los 365 días del año',
      cause: 'Por motivos de seguridad y calidad la llamada será grabada. Para conocer cómo usamos tus datos, consulta la',
      policy: 'política de privacidad',
      msg: {
        send: 'Enviando solicitud',
        ok: 'Solicitud enviada correctamente',
        ko: 'Error al enviar solicitud',
      },
    },
    news: {
      title: 'Noticias',
      empty: 'No se ha encontrado ninguna noticia',
    },
    pulsoDigital: {
      title: 'Interrupciones de servicio',
      description: 'Consulta las interrupciones de servicio de aplicaciones identificadas en el Centro de Servicios al Usuario.',
      initDate: 'Inicio de la parada: {0}',
      duration: 'Duración estimada: {0}h',
      statuses: {
        FIX: 'Pte. confirmar cierre',
        OP: 'Abierta',
        DEL: 'Planificada',
        PEND_APRO: 'Pte aprobar',
        PL_ENT: 'Pte. implantar',
        CL: 'Cerrada',
        CNCL: 'Cancelada',
        RCHZ: 'Rechazada',
        PEND_PRES: 'Pte. presupuesto',
      },
      type: {
        R: 'P',
        I: 'I',
        P: 'Pr',
      },
      empty: 'No hay eventos',
      addSubscription: 'Realizando la acción',
      createSubscription: 'Acción completada con éxito',
      errorSubscription: 'Eres seguidor de esta solicitud',
      koSubscription: 'No se pudo completar la acción',
    },
    pulsoDigitalProacS: {
      title: 'Incidencias proactivas',
      description: 'Este listado muestra incidencias registradas automáticamente por los sistemas de monitorización proactiva',
      empty: 'No hay Incidencias Proactivas que mostrar',
    },
    registered: {
      title: '¡Tu solicitud {0} se ha registrado correctamente!',
      titleMobile: '¡Tu solicitud se ha registrado correctamente!',
      subtitle: 'Ahora puedes hacer seguimiento fácilmente desde nuestra app o por WhatsApp.',
      titleDetails: 'Ver detalle de tu solicitud',
      subtitleDetails: 'Si prefieres, puedes ver el detalle ahora de tu solicitud',
      btnDetail: 'Ver detalle',
      titleWhatsApp: 'Haz seguimiento por WhatsApp',
      subtitleWhatsApp: 'Escanea este código QR desde tu móvil para abrir la conversación en WhatsApp.',
      subtitleMobile: 'También puedes consultar tu solicitud escribiendonos por WhatsApp.',
      btnWhatsApp: 'Abrir WhatsApp',
      titleDownload: 'Descarga nuestra app',
      titleApp: 'Utiliza nuestra app',
      subtitleDownload1: 'Consultar el estado de tus solicitudes',
      subtitleDownload2: 'Recibir notificaciones',
      subtitleDownload3: 'Acceder a otros servicios digitales',
      openApp: 'Abrir APP',
      downloadApp: 'Ir al Store',
    },
  },
  components: {
    carouselMarquee: {
      link: 'Suscríbete',
    },
    news: {
      title: 'Destacados',
      switch: 'No volver a mostrar esta noticia',
    },
    cardpopup: {
      viewMore: 'Ver más',
    },
    lastNotificationsPopup: {
      title: 'Últimas notificaciones',
    },
    listNavigator: {
      backButton: 'Ir al listado',
    },
    share: {
      title: 'Compartir',
      clipboard: {
        action: 'Enlace',
        textCopied: 'Enlace copiado al portapapeles',
      },
      mail: 'Email',
      pushSMS: {
        action: 'Móvil',
        create: 'Enviando notificación',
        share: 'Se ha enviado al teléfono',
        shareFail: 'No se ha podido realizar el envío. Disculpas las molestias.',
        TitleKI: 'Solución compartida',
        TitleNews: 'Noticia compartida',
        TitlePulso: 'Solicitud compartida',
        TitleForm: 'Formulario de registro compartido',
        TextKI: 'Has compartido la solución {0} desde la web. Haz clic para consultarla.',
        TextForm: 'Has compartido el formulario {0} desde la web. Haz clic para verlo.',
        TextNews: 'Has compartido la novedad {0} desde la web. Haz click para verla.',
        TextPulso: 'Has compartido la solicitud {0} desde la web. Haz click para verla.',
      },
      whatsapp: {
        action: 'WhatsApp',
        create: 'Enviando notificación',
        share: 'Se ha enviado al teléfono',
        shareFail: 'No ha sido posible compartir el enlace',
      },
      mobile: {
        knowledgeItems: 'Compartir solución',
        requestCreation: 'Compartir petición de catálogo',
        noticeItem: 'Compartir noticia',
      },
      subjectBody: {
        R: 'Enlace a petición de área personal ayudaDIGITAL:',
        I: 'Enlace a incidencia de área personal ayudaDIGITAL:',
        knowledge: 'Enlace a solución de área personal ayudaDIGITAL:',
        general: 'Enlace de acceso a',
        notice: 'Enlace a notica de área personal ayudaDIGITAL:',
      },
    },
    altiris: {
      load: 'Recuperando los últimos equipos donde has iniciado sesión...',
      result: 'Estos son los equipos donde has iniciado sesión en las últimas 96 horas:',
      title: 'Selecciona el dispositivo que tiene la incidencia:',
      notFound: 'No se ha recuperado ningún equipo con inicio de sesión en las últimas 96 horas',
      show: '({0})',
      showLastSession: 'Último inicio sesión {0}.',
      edificio: 'Edificio:',
      floor: 'Planta:',
      centro: 'Centro:',
      room: 'Sala:',
      seccion: 'Sección:',
      not: 'No es ninguno de estos dispositivos.',
      name: 'Nombre:',
      cod: 'Código:',
    },
    searchBox: {
      viewMore: 'Ver más',
      list: 'IR AL LISTADO',
      emptyMessage: 'No se ha encontrado ningún resultado.',
      formGeneric: 'No se ha encontrado ningún resultado para tu búsqueda, inténtalo con otros criterios.',
      linkFormGeneric: 'aquí.',
      atLeastOneFilter: 'Debes seleccionar al menos un estado.',
    },
    file: {
      maxFiles: 'Nº máximo de ficheros: 8',
      maxSize: 'Tamaño máximo: 20 MB',
      placeholder: 'Suelta los archivos, pega una captura de pantalla o haz click aquí',
      placeholderApp: 'Haz una foto o click aquí',
    },
    search: {
      noDataMessage: 'o pulsar',
      noDataMessageContinue: 'para una búsqueda más extendida',
      noFilter: 'Introduce algún valor para acotar los resultados de la búsqueda',
    },
    barCodeScanner: {
      barCodeNotFound: 'No se ha encontrado ningún equipo con código {0}',
    },
  },
  ticketActions: {
    noView: 'Lo sentimos, no tienes permisos para visualizar esa solicitud.',
    noViewTic: 'No tienes permiso para visualizar esta solicitud',
    noViewPage: 'No tienes permisos para acceder a esta página',
    noViewExist: 'Esta página no existe o ha cambiado de sitio.',
    send: 'Enviar',
    cancelSend: 'Cancelar',
    messages: {
      creating: 'Realizando la acción',
      success: 'Acción completada con éxito',
      error: 'No se pudo completar la acción',
      errorAttach: 'No se pudo completar la acción de adjuntar',
      errorComment: 'No se pudo completar la acción de comentar',
      errorClaim: 'No se pudo completar la acción de reclamar',
    },
    comment: {
      title: 'Comentar',
      placeholder: 'Por favor, introduce un comentario',
      sendComment: 'Enviar',
      creating: 'Enviando comentario',
      success: 'Se ha añadido el comentario a tu solicitud',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
      send: 'Comentar',
    },
    claim: {
      title: 'Reclamar',
      claimType: 'Tipo de reclamación',
      text: 'Por favor, introduce un comentario',
      sendClaim: 'Reclamar',
      creating: 'Enviando reclamación',
      success: 'Tu solicitud ha sido reclamada',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    acceptClosing: {
      title: 'Confirmar cierre',
      commentLabel: 'Tu solicitud será cerrada',
      placeholder: 'Puedes añadir un comentario para el cierre de tu solicitud',
      valorationPlaceholder: '¿Quieres aportar alguna información adicional a tu valoración?',
      scoreLabel: '¿Quieres valorar cómo te hemos atendido?',
      workflowLabel: 'Los técnicos que han actuado en tu solicitud son:',
      submit: 'Confirmar',
      creating: 'Aceptando la solicitud',
      success: 'Tu solicitud ha sido cerrada',
      error: 'Ocurrió un error su aceptación',
      thanks: '¡Gracias! <br/> Tu opinión nos ayuda a mejorar',
      sorry: 'Lo sentimos <br/> Trabajaremos para seguir mejorando',
    },
    cancel: {
      title: 'Cancelar',
      placeholder: 'Por favor, introduce un comentario',
      text: 'Por favor, introduce un comentario',
      sendComment: 'Cancelar',
      creating: 'Cancelando la solicitud',
      success: 'Tu solicitud ha sido cancelada',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    attach: {
      title: 'Adjuntar documento',
      sendAttach: 'Adjuntar',
      attachDocuments: 'Adjuntar fichero',
      comment: 'Puedes añadir un comentario',
      creating: 'Enviando fichero',
      success: 'El fichero se ha adjuntado correctamente',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    approve: {
      title: 'Aprobar',
      placeholder: 'Puedes añadir un comentario',
      text: 'Comentario',
      check: 'Confirmo que he revisado esta solicitud y autorizo su tramitación, asumiendo la responsabilidad de esta aprobación. Esta acción quedará registrada en el historial de la solicitud.',
      requiredCheck: 'Debes confirmar la autorización para continuar.',
      sendComment: 'Aprobar',
      creating: 'Aprobando la solicitud',
      success: 'La solicitud ha sido aprobada',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    reject: {
      title: 'Rechazar',
      placeholder: 'Por favor, introduce un comentario',
      text: 'Comentario',
      sendComment: 'Rechazar',
      creating: 'Rechazando la solicitud',
      success: 'La solicitud ha sido rechazada',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    resolve: {
      title: 'Resolver',
      placeholder: 'Por favor, introduce el comentario de resolución',
      text: 'Comentario',
      sendComment: 'Resolver',
      creating: 'Resolviendo la solicitud',
      success: 'La solicitud ha sido resuelta',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    escalate: {
      title: 'Escalar',
      placeholder: 'Por favor, introduce un comentario',
      text: 'Comentario',
      sendClaim: 'Escalar',
      creating: 'Escalando la solicitud',
      success: 'Su petición ha sido escalada',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
      assignee: 'Asignar a',
    },
    export: {
      title: 'Exportar',
      creating: 'Generando el documento',
      success: 'Su documento se ha generado correctamente',
      error: 'Ocurrió un error generando su documento',
    },
    clone: {
      title: 'Clonar',
      creating: 'Clonando tu solicitud',
      success: 'Estás clonando una solicitud, se copiarán todos los datos excepto los documentos adjuntos',
      error: 'Ocurrió un error clonando su solicitud',
    },
    transfer: {
      search: 'Usuarios',
      title: 'Escalar',
      label: 'Escalar a',
      send: 'Escalar',
      creating: 'Escalando la solicitud.',
      success: 'Su petición ha sido escalada.',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos.',
      noData: 'No hay datos disponible.',
    },
    interesado: {
      title: 'Interesados',
      subtitle: 'Las personas que incluyas como interesados recibirán notificación cada vez que se actualice la solicitud y podrán consultar y hacer cualquier acción sobre ella (máximo 10 personas)',
      list: 'Lista de interesados (podrán realizar cualquier acción sobre esta solicitud).',
      create: 'Actualizando interesados.',
      createSuccess: 'Interesados actualizados correctamente.',
      createError: 'Ocurrió un error actualizando a los interesados.',
      delete: 'Eliminando interesados.',
      deleteProcess: 'Interesados eliminados correctamente.',
      deletingError: 'Ocurrió un error eliminando a los interesados.',
      max: 'Has alcanzado el número máximo de interesados.',
      noBody: 'No hay interesados.',
      error: 'Lo sentimos, no se ha podido completar el proceso. Inténtalo de nuevo mas tarde.',
      success: 'El proceso se ha completado correctamente.',
    },
    share: {
      title: 'Compartir',
    },
    follow: {
      title: 'Seguir',
      create: 'Siguiendo solictud.',
      createSuccess: 'Se ha seguido la solicitud correctamente.',
      createError: 'Ocurrió un error siguiendo la solicitud.',
    },
    follownot: {
      title: 'Dejar de Seguir',
      create: 'Dejando de seguir la solictud.',
      createSuccess: 'Se ha dejado de seguir la solicitud correctamente.',
      createError: 'Ocurrió un error al dejar de seguir la solicitud.',
    },
  },
  follow: {
    title: 'Seguir',
    create: 'Siguiendo solictud.',
    createSuccess: 'Se ha seguido la solicitud correctamente.',
    createError: 'Ocurrió un error siguiendo la solicitud.',
  },
  follownot: {
    title: 'Dejar de Seguir',
    create: 'Dejando de seguir la solictud.',
    createSuccess: 'Se ha dejado de seguir la solicitud correctamente.',
    createError: 'Ocurrió un error al dejar de seguir la solicitud.',
  },
  share: {
    title: 'Compartir',
  },
  listActions: {
    approveAll: {
      placeholder: 'Por favor, introduce un comentario para tu aprobación',
      errorForm: 'Debes seleccionar al menos una solicitud',
      send: 'Aprobar',
      creating: 'Aprobando solicitud | Aprobando solicitudes',
      successTicket: 'La solicitud ha sido aprobada | Las solicitudes han sido aprobadas',
      errorsTicket: 'No se han podido aprobar las siguientes solicitudes: ',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
    rejectAll: {
      placeholder: 'Por favor, introduce un comentario para tu rechazo',
      errorForm: 'Debes seleccionar al menos una solicitud',
      send: 'Rechazar',
      creating: 'Rechazando solicitud | Rechazando solicitudes',
      successTicket: 'La solicitud ha sido rechazada | Las solicitudes han sido rechazadas',
      errorsTicket: 'No se han podido rechazar las siguientes solicitudes: ',
      error: 'No se ha podido completar la acción, inténtalo de nuevo en unos minutos',
    },
  },
  list: {
    empty: 'No hay resultado para tu búsqueda',
  },
  stopMobileNotif: {
    title: 'Pausar notificaciones',
    labelDateSuscription: 'Desde - Hasta',
    labelDateStart: 'Desde',
    hintDateStart: 'Periodo máximo: 30 días',
    labelDateEnd: 'Hasta',
    labelCombo: 'Definir periodo',
    errors: {
      required: 'Debe seleccionar un rango o periodo',
      requiredRange: 'Debe indicar un rango de pausa',
      wrongDates: 'La fecha de inicio debe ser anterior a la fecha de fin',
      maxDays: 'Máximo 30 días entre ambas fechas',
    },
    successPause: 'Notificaciones pausadas',
    successDelete: 'Notificaciones activadas',
    error: 'Se ha producido un error',
    sending: 'Enviando solicitud',
    buttons: {
      calendar: {
        ok: 'OK',
        cancel: 'CANCELAR',
      },
      pause: 'ACEPTAR',
      deleteNotifications: '',
    },
    pausedNotificationsTitle: 'Notificaciones pausadas',
  },
  formUserPerfil: {
    dirayaModules: {
      notDirayaModulesAssigned: 'No tienes ningún módulo DIRAYA asignado.',
    },
  },
  sessionTimeoutWarning: {
    title: 'La sesión expirará pronto',
    message: '¡Atención! Su sesión está a punto de caducar. Por favor, presione continuar para mantener la sesión',
    buttons: {
      logout: 'Cerrar sesión',
      continue: 'Continuar',
    },
  },
};
